import { createIcon } from '@chakra-ui/icon';
export var UserIcon = createIcon({
  displayName: 'UserIcon',
  d: 'M7 7a5 5 0 1110 0A5 5 0 017 7zm5-7a7 7 0 100 14 7 7 0 000-14zM3.131 22.151A6 6 0 019.072 17h5.858a6 6 0 015.94 5.151l.141.99a1 1 0 101.98-.282l-.141-.99A8 8 0 0014.929 15H9.071a8 8 0 00-7.92 6.869l-.14.99a1 1 0 001.98.282l.14-.99z'
});
//# sourceMappingURL=User.js.map